<template>
    <componentType :task="item" />
</template>
<script setup>
import { computed } from 'vue'
import Job from './JobEndedTaskItem'
import JobRole from './JobRoleEndedTaskItem'
import JobTitle from './JobTitleEndedTaskItem'

const props = defineProps({
    item: {
        type: Object,
        required: true,
    },
})

const components = {
    Job,
    JobRole,
    JobTitle,
}

const componentType = computed(() => components[props.item.secondaryEntityType])
</script>
